// (00) 00000-0000
export const phoneMask = (value = '') => {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})/, '$1-$2');
};

// (00) 0000-0000
export const landlineTelephoneMask = (value = '') => {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{4})(\d{4})/, '$1-$2');
};

export const cellphoneMaskV2 = (value = '') => {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1');
};

export const landlinePhoneMaskV2 = (value = '') => {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{4})(\d{4})/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1');
};

export const anyPhoneMaskV2 = (value = '') => {
  const clear = value.replace(/\D/g, '');
  if (clear.length <= 10) return landlinePhoneMaskV2(value);
  return cellphoneMaskV2(value);
};

// 000.000.000-00
export const cpfMask = (value = '') => {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
};

export function telephoneMask(v = '') {
  let r = v.replace(/\D/g, '');
  r = r.replace(/^0/, '');
  if (r.length > 10) {
    r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
  } else if (r.length > 5) {
    r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, '($1) $2-$3');
  } else if (r.length > 2) {
    r = r.replace(/^(\d\d)(\d{0,5})/, '($1) $2');
  } else {
    r = r.replace(/^(\d*)/, '($1');
  }
  if (r[r.length - 1] === '-') {
    return r.slice(0, -1);
  } else if (r === '(') {
    return '';
  }

  return r;
}
// 00.000.000/0000-00
export const cnpjMask = (value = '') => {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
};

// 000.000.000-00 ou 00.000.000/0000-00
export const cpfcnpjMask = (value = '') => {
  const stringValue = value.toString().trim();
  if (stringValue.length < 15)
    return stringValue
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2');
  else
    return stringValue
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
};

// 00000-000
export const cepMask = (value = '') => {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');
};

// ABC-0000
export const plateMask = (value = '') => {
  const stringValue = value.toString();

  const letters = stringValue
    .replace(/[^a-z]/gi, '')
    .slice(0, 3)
    .toUpperCase();

  const numbers = stringValue.slice(3, 8).replace(/\D/gi, '');

  return `${letters}-${numbers}`;
};

export const proposalMask = (value = '') => {
  const stringValue = value.toString();

  return stringValue.replace(/\D/gi, '').slice(0, 9);
};

export const numbersAndLettersMask = (value = '') => {
  const stringValue = value.toString();

  return stringValue.replace(/[^A-Za-z0-9]+/gi, '');
};

export const numbersAndLettersMaskUppercase = (value = '') => {
  const stringValue = value.toString();

  return stringValue.replace(/[^A-Za-z0-9]+/gi, '').toUpperCase();
};

export const registrationMask = (value = '') => {
  const stringValue = value.toString();
  return stringValue.replace(/\D/g, '');
};

export function cellphoneMask2(value = '') {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1');
}

export function landlinePhoneMask2(value = '') {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{4})(\d{4})/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1');
}

export function phoneMask2(value = '') {
  const clean = String(value).replace(/\D/g, '');

  if (clean.length <= 10) return landlinePhoneMask2(value);
  return cellphoneMask2(value);
}
export const onlyLetters = (value = '') => {
  const stringValue = value.toString();
  return stringValue.replace(/\d/g, '');
};

export const maskEmail = (value = '') => {
  const stringValue = value.toString();
  return stringValue.replace(/\s/g, '');
};
